import React, { useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const CompareSlider = ({ before, after, beforeAlt, afterAlt }) => {
  const [pos, setPos] = useState(50);
  return (
    <div data-testid="compare-slider" className="relative w-full aspect-square overflow-hidden rounded-3xl bg-slate-100 select-none">
      <img src={after} alt={afterAlt} className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <img src={before} alt={beforeAlt} data-testid="compare-before-img" className="absolute inset-0 w-full h-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} draggable={false} />
      <span className="absolute top-4 left-4 text-xs font-bold px-3 py-1 rounded-full bg-white/90 text-[#0a1f44]">Before</span>
      <span className="absolute top-4 right-4 text-xs font-bold px-3 py-1 rounded-full bg-[#3b9dff] text-white">After</span>
      <div className="pointer-events-none absolute inset-y-0 w-0.5 bg-white shadow" style={{ left: `${pos}%` }}>
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 left-1/2 w-11 h-11 rounded-full bg-white shadow-lg flex items-center justify-center">
          <MoveHorizontal className="w-5 h-5 text-[#0a1f44]" />
        </span>
      </div>
      <input
        type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Drag to compare before and after" data-testid="compare-slider-input"
        className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
      />
    </div>
  );
};
